"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typesafe_actions_1 = require("typesafe-actions");
var DbarAction;
(function (DbarAction) {
    DbarAction.ON_TOGGLE_FILTER = 'ON_TOGGLE_FILTER';
    DbarAction.ON_TOGGLE_SORT = 'ON_TOGGLE_SORT';
    DbarAction.SET_DBAR_POP = 'SET_DBAR_POP';
    DbarAction.ON_BACK_CLICKED = 'ON_BACK_CLICKED';
    DbarAction.onToggleFilter = typesafe_actions_1.createAction(DbarAction.ON_TOGGLE_FILTER, function (resolve) { return function () { return resolve(); }; });
    DbarAction.onToggleSort = typesafe_actions_1.createAction(DbarAction.ON_TOGGLE_SORT, function (resolve) { return function () { return resolve(); }; });
    DbarAction.setDbarPop = typesafe_actions_1.createAction(DbarAction.SET_DBAR_POP, function (resolve) { return function (pop) { return resolve(pop); }; });
    DbarAction.onBackClicked = typesafe_actions_1.createAction(DbarAction.ON_BACK_CLICKED, function (resolve) { return function () { return resolve(); }; });
})(DbarAction || (DbarAction = {}));
exports.default = DbarAction;
